/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InitializeTaxDeclarationBySmzhIdCommand } from '../../models/initialize-tax-declaration-by-smzh-id-command';

export interface ApiTaxDeclarationInitializeSalesforceInsertPost$Plain$Params {
      body: InitializeTaxDeclarationBySmzhIdCommand
}

export function apiTaxDeclarationInitializeSalesforceInsertPost$Plain(http: HttpClient, rootUrl: string, params: ApiTaxDeclarationInitializeSalesforceInsertPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, apiTaxDeclarationInitializeSalesforceInsertPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

apiTaxDeclarationInitializeSalesforceInsertPost$Plain.PATH = '/api/TaxDeclaration/initialize-salesforce-insert';
